import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

const SuccessModal = (props) => {
  const { open, onClose, knowledgeWebinarRegister } = props;
  const [successMessage, setSuccessMesage] = useState();

  useEffect(() => {
    if (knowledgeWebinarRegister && knowledgeWebinarRegister.webinarRegistration  && knowledgeWebinarRegister.webinarRegistration.message) {
      setSuccessMesage(knowledgeWebinarRegister.webinarRegistration.message);
    }
  }, [knowledgeWebinarRegister]);

  return (
    <div>
      <Modal
        isOpen={open}
        onRequestClose={onClose}
        contentLabel="Example Modal"
        className="webinarrmodal"
      >
        <div>
          <div className="container d-flex justify-content-between">
            <p className="successtext">{successMessage}</p>
            <img
              src="/images/New/red-arrow-close.svg"
              width={25}
              height={25}
              alt="close"
              className="btn-close successclose"
              onClick={onClose}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => ({
  knowledgeWebinarRegister: state.KnowledgeStack,
});

const mapDispatchToProps = (dispatch) => ({
  //   getCallUsContent: bindActionCreators(getCallUsContent, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuccessModal);
